import { InfoRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";

interface IMobileRequiredModalProps {
    isOpen: boolean;
    onAddMobile(): void;
}

export const MobileRequiredModal = (props: IMobileRequiredModalProps) => {
    const { isOpen, onAddMobile } = props;
    const { t } = useTranslation("cart");

    return (
        <Modal
            confirm={onAddMobile}
            confirmLabel={t("broadbandMobileRequired.addMobileButton")}
            disableCloseOnBackdropClick
            isAlertModal
            isModalOpen={isOpen}
            title={t("broadbandMobileRequired.title")}
        >
            <Box alignItems="center" columnGap={2} display="flex" justifyContent="center" width="100%">
                <InfoRounded color="secondary" />
                <Typography color="secondary" variant="body1">
                    {t("broadbandMobileRequired.message")}
                </Typography>
            </Box>
        </Modal>
    );
};
